import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage, useIntl} from 'react-intl'
import {Box, Text, Button} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useToast} from '../../../hooks/use-toast'

const EngravingButtons = (props) => {
    const {
        showInitialSpinner,
        isRedtrictedWordActive,
        engravingLines,
        restrictionListArray,
        selectedFont,
        disableAddToBag,
        setShowApiSpinner,
        setEngravingImages,
        setDesktopGalleryEngImages,
        saveRecipe,
        setDriveRecipeID,
        getHash,
        makeEngravingGtmObject,
        addToCart,
        variant,
        onAddToCartDrawerOpen,
        product,
        priceData,
        setOpenBonusModal,
        monetate,
        customer,
        wishlist,
        setShowAddedCta,
        tagManager,
        onClose,
        navigate,
        setOpenEngraving,
        setEngravingChecksum,
        setEngravingGtmObject,
        isEditEngraving,
        showAddedCta,
        productQuantity,
        updateItemInBasketMutation,
        basket,
        productUuid
    } = props
    const showToast = useToast()
    const intl = useIntl()
    return (
        <Box
            gap="10px"
            margin="20px 0 60px 0"
            display="grid"
            borderTop="1px solid"
            borderColor="gray.400"
            paddingTop="20px"
        >
            <Button
                variant="solid"
                height="56px"
                isLoading={showInitialSpinner}
                letterSpacing="0.085px"
                fontSize="17px"
                isDisabled={
                    isRedtrictedWordActive(engravingLines, restrictionListArray, selectedFont) ||
                    disableAddToBag
                }
                cursor={
                    isRedtrictedWordActive(engravingLines, restrictionListArray, selectedFont)
                        ? 'not-allowed'
                        : 'pointer'
                }
                width="100%"
                borderRadius="90px"
                onClick={async () => {
                    setShowApiSpinner(true)
                    if (
                        isRedtrictedWordActive(engravingLines, restrictionListArray, selectedFont)
                    ) {
                        return
                    }
                    const face1Name =
                        document.querySelectorAll('#face-wrapper div:not(.hide-element)')?.[0]
                            ?.innerText === 'Front' ||
                        document.querySelectorAll('#face-wrapper div:not(.hide-element)')?.[0]
                            ?.innerText === 'Top'
                            ? document.querySelectorAll('#face-wrapper div:not(.hide-element)')?.[0]
                                  ?.innerText
                            : undefined
                    const face2Name =
                        document.querySelectorAll('#face-wrapper div:not(.hide-element)')?.[0]
                            ?.innerText === 'Back'
                            ? document.querySelectorAll('#face-wrapper div:not(.hide-element)')?.[0]
                                  ?.innerText
                            : document.querySelectorAll('#face-wrapper div:not(.hide-element)')?.[1]
                                  ?.innerText
                    const isBackOnly =
                        window?.engravingInstance?.configuratorSetup?.views?.face_1?.name === 'Back'
                    const face1LinesAvailable =
                        selectedFont.face_1 === 'Monogram'
                            ? engravingLines.face_1.monogram
                            : engravingLines.face_1.line1 ||
                              engravingLines.face_1.line2 ||
                              engravingLines.face_1.line3 ||
                              engravingLines.face_1.line4 ||
                              engravingLines.face_1.line5
                    const activeFace2 = isBackOnly ? 'face_1' : 'face_2'
                    const face2LinesAvailable =
                        selectedFont?.[activeFace2] === 'Monogram'
                            ? engravingLines[activeFace2].monogram
                            : engravingLines[activeFace2].line1 ||
                              engravingLines[activeFace2].line2 ||
                              engravingLines[activeFace2].line3 ||
                              engravingLines[activeFace2].line4 ||
                              engravingLines[activeFace2].line5
                    if (face1LinesAvailable || face2LinesAvailable) {
                        const img1 = face1Name
                            ? 'https:' +
                              (isBackOnly
                                  ? window.engravingImage.frames?.[window.engravingImage.frame]?.url
                                  : window.engravingImage.frames?.[1]?.url)
                            : null
                        const img2 = face2Name
                            ? 'https:' +
                              (isBackOnly
                                  ? window.engravingImage.frames?.[window.engravingImage.frame]?.url
                                  : window.engravingImage.frames?.[2]?.url)
                            : null
                        const images = {
                            face1: {
                                image: face1LinesAvailable ? img1 : null,
                                name: face1LinesAvailable ? face1Name : null
                            },
                            face2: {
                                image: face2LinesAvailable ? img2 : null,
                                name: face2LinesAvailable ? face2Name : null
                            }
                        }
                        setEngravingImages(images)
                        setDesktopGalleryEngImages(images)
                        setShowApiSpinner(true)
                        saveRecipe().then(async (result) => {
                            setDriveRecipeID(result.id)
                            const activeStates = {
                                face_1: {
                                    name: 'face_1-text',
                                    hasValue: isBackOnly ? false : !!face1LinesAvailable,
                                    value: isBackOnly
                                        ? ''
                                        : selectedFont?.face_1 === 'Monogram'
                                        ? engravingLines?.face_1.monogram
                                        : `${engravingLines.face_1.line1 || ''}${
                                              engravingLines.face_1.line2
                                                  ? '\n' + engravingLines.face_1.line2
                                                  : ''
                                          }${
                                              engravingLines.face_1.line3
                                                  ? '\n' + engravingLines.face_1.line3
                                                  : ''
                                          }${
                                              engravingLines.face_1.line4
                                                  ? '\n' + engravingLines.face_1.line4
                                                  : ''
                                          }${
                                              engravingLines.face_1.line5
                                                  ? '\n' + engravingLines.face_1.line5
                                                  : ''
                                          }`.trim(),
                                    fontFamily: selectedFont.face_1
                                },
                                face_1_right: {
                                    name: 'face_1-right-text',
                                    hasValue: false,
                                    value: ''
                                },
                                face_2: {
                                    name: 'face_2-text',
                                    hasValue: !!face2LinesAvailable,
                                    value:
                                        selectedFont?.[isBackOnly ? 'face_1' : 'face_2'] ===
                                        'Monogram'
                                            ? engravingLines?.[isBackOnly ? 'face_1' : 'face_2']
                                                  ?.monogram
                                            : `${
                                                  engravingLines?.[isBackOnly ? 'face_1' : 'face_2']
                                                      .line1 || ''
                                              }${
                                                  engravingLines?.[isBackOnly ? 'face_1' : 'face_2']
                                                      .line2
                                                      ? '\n' +
                                                        engravingLines?.[
                                                            isBackOnly ? 'face_1' : 'face_2'
                                                        ].line2
                                                      : ''
                                              }${
                                                  engravingLines?.[isBackOnly ? 'face_1' : 'face_2']
                                                      .line3
                                                      ? '\n' +
                                                        engravingLines?.[
                                                            isBackOnly ? 'face_1' : 'face_2'
                                                        ].line3
                                                      : ''
                                              }${
                                                  engravingLines?.[isBackOnly ? 'face_1' : 'face_2']
                                                      .line4
                                                      ? '\n' +
                                                        engravingLines?.[
                                                            isBackOnly ? 'face_1' : 'face_2'
                                                        ].line4
                                                      : ''
                                              }${
                                                  engravingLines?.[isBackOnly ? 'face_1' : 'face_2']
                                                      .line5
                                                      ? '\n' +
                                                        engravingLines?.[
                                                            isBackOnly ? 'face_1' : 'face_2'
                                                        ].line5
                                                      : ''
                                              }`.trim(),
                                    fontFamily: selectedFont?.[isBackOnly ? 'face_1' : 'face_2']
                                },
                                face_2_right: {
                                    name: 'face_2-right-text',
                                    hasValue: false,
                                    value: '',
                                    fontFamily: ''
                                }
                            }
                            const engravingChecksum = getHash(activeStates)
                            const engravingGtmObject = makeEngravingGtmObject(
                                selectedFont,
                                engravingLines
                            )
                            try {
                                const response = await addToCart(
                                    variant,
                                    1,
                                    result.id,
                                    engravingChecksum,
                                    engravingGtmObject
                                )
                                setShowApiSpinner(false)
                                const {productSelectionValues: itemsAdded, basketResponse} =
                                    response || {}
                                if (itemsAdded) {
                                    onAddToCartDrawerOpen({
                                        product,
                                        itemsAdded,
                                        selectedQuantity: 1,
                                        priceData: priceData
                                    })
                                    setOpenBonusModal(true)
                                    monetate.monetateTrackPage(
                                        'addToBagModal',
                                        window.mtBreadcrumb,
                                        basketResponse?.productItems,
                                        customer?.customerType === 'registered',
                                        wishlist?.customerProductListItems?.length || 0,
                                        null,
                                        null,
                                        itemsAdded,
                                        basketResponse?.giftCertificateItems
                                    )
                                    setShowAddedCta(true)
                                    window.setTimeout(() => {
                                        setShowAddedCta(false)
                                    }, 3000)
                                    tagManager.addToCart(
                                        product,
                                        variant,
                                        null,
                                        null,
                                        'pdp',
                                        null,
                                        false,
                                        engravingGtmObject
                                    )
                                    setEngravingGtmObject(engravingGtmObject)
                                    onClose()
                                    navigate(location.pathname)
                                    setOpenEngraving(false)
                                    setEngravingChecksum(getHash(activeStates))
                                    setShowApiSpinner(false)
                                    window.scrollTo({top: 0, behavior: 'smooth'})
                                }
                            } catch (e) {
                                setEngravingChecksum(getHash(activeStates))
                                setEngravingGtmObject(engravingGtmObject)
                                setShowAddedCta(false)
                                setShowApiSpinner(false)
                            }
                        })
                    } else {
                        if (isEditEngraving) {
                            try {
                                const response = await addToCart(variant, 1) // No need to send Engraving data because nothing is engraved here
                                setShowApiSpinner(false)
                                const {productSelectionValues: itemsAdded, basketResponse} =
                                    response || {}
                                if (itemsAdded) {
                                    onAddToCartDrawerOpen({
                                        product,
                                        itemsAdded,
                                        selectedQuantity: 1,
                                        priceData: priceData
                                    })
                                    setOpenBonusModal(true)
                                    monetate.monetateTrackPage(
                                        'addToBagModal',
                                        window.mtBreadcrumb,
                                        basketResponse?.productItems,
                                        customer?.customerType === 'registered',
                                        wishlist?.customerProductListItems?.length || 0,
                                        null,
                                        null,
                                        itemsAdded,
                                        basketResponse?.giftCertificateItems
                                    )
                                    setShowAddedCta(true)
                                    window.setTimeout(() => {
                                        setShowAddedCta(false)
                                    }, 3000)
                                    tagManager.addToCart(product, variant, null, null, 'pdp')
                                    onClose()
                                    setOpenEngraving(false)
                                    navigate(location.pathname)
                                    window.scrollTo({top: 0, behavior: 'smooth'})
                                }
                            } catch (e) {
                                setShowAddedCta(false)
                                setShowApiSpinner(false)
                            }
                        }
                        if (!isEditEngraving) {
                            document.querySelector('.add-to-cart-wrapper button').click()
                        }
                        setOpenEngraving(false)
                        setEngravingImages({
                            face1: null,
                            face2: null
                        })
                        setDesktopGalleryEngImages(null)
                        setDriveRecipeID('')
                        onClose()
                        setShowApiSpinner(false)
                    }
                }}
            >
                {showAddedCta ? (
                    <FormattedMessage
                        defaultMessage="Added"
                        id="product_view.button.added_to_cart"
                    />
                ) : isEditEngraving ? (
                    <FormattedMessage id="update.engraving" defaultMessage="Update Engraving" />
                ) : (
                    <FormattedMessage
                        id="add.with.engraving"
                        defaultMessage="Add to Bag with Engraving"
                    />
                )}
            </Button>
            <Box
                display={{base: 'inline-flex', md: 'contents'}}
                gap="10px"
                margin="auto"
                alignItems={{base: 'center', md: 'unset'}}
            >
                {!isEditEngraving && (
                    <Button
                        variant={{base: 'link', md: 'outline'}}
                        height="56px"
                        fontSize={{base: '14px', md: '17px'}}
                        letterSpacing="0.085px"
                        isDisabled={isRedtrictedWordActive(
                            engravingLines,
                            restrictionListArray,
                            selectedFont
                        )}
                        cursor={
                            isRedtrictedWordActive(
                                engravingLines,
                                restrictionListArray,
                                selectedFont
                            )
                                ? 'not-allowed'
                                : 'pointer'
                        }
                        width={{base: 'fit-content', md: '100%'}}
                        borderRadius="90px !important"
                        borderColor="gray.800 !important"
                        textUnderlineOffset="4px"
                        textDecoration={{base: 'underline', md: 'none'}}
                        color="black.100 !important"
                        border={{base: '0px', md: '1px solid'}}
                        onClick={() => {
                            setShowApiSpinner(true)
                            if (
                                isRedtrictedWordActive(
                                    engravingLines,
                                    restrictionListArray,
                                    selectedFont
                                )
                            ) {
                                return
                            }
                            const face1Name =
                                document.querySelectorAll(
                                    '#face-wrapper div:not(.hide-element)'
                                )?.[0]?.innerText === 'Front' ||
                                document.querySelectorAll(
                                    '#face-wrapper div:not(.hide-element)'
                                )?.[0]?.innerText === 'Top'
                                    ? document.querySelectorAll(
                                          '#face-wrapper div:not(.hide-element)'
                                      )?.[0]?.innerText
                                    : undefined
                            const face2Name =
                                document.querySelectorAll(
                                    '#face-wrapper div:not(.hide-element)'
                                )?.[0]?.innerText === 'Back'
                                    ? document.querySelectorAll(
                                          '#face-wrapper div:not(.hide-element)'
                                      )?.[0]?.innerText
                                    : document.querySelectorAll(
                                          '#face-wrapper div:not(.hide-element)'
                                      )?.[1]?.innerText
                            const isBackOnly =
                                window?.engravingInstance?.configuratorSetup?.views?.face_1
                                    ?.name === 'Back'
                            const face1LinesAvailable =
                                selectedFont.face_1 === 'Monogram'
                                    ? engravingLines.face_1.monogram
                                    : engravingLines.face_1.line1 ||
                                      engravingLines.face_1.line2 ||
                                      engravingLines.face_1.line3 ||
                                      engravingLines.face_1.line4 ||
                                      engravingLines.face_1.line5
                            const activeFace2 = isBackOnly ? 'face_1' : 'face_2'
                            const face2LinesAvailable =
                                selectedFont?.[activeFace2] === 'Monogram'
                                    ? engravingLines[activeFace2].monogram
                                    : engravingLines[activeFace2].line1 ||
                                      engravingLines[activeFace2].line2 ||
                                      engravingLines[activeFace2].line3 ||
                                      engravingLines[activeFace2].line4 ||
                                      engravingLines[activeFace2].line5
                            if (face1LinesAvailable || face2LinesAvailable) {
                                const img1 = face1Name
                                    ? 'https:' +
                                      (isBackOnly
                                          ? window.engravingImage.frames?.[
                                                window.engravingImage.frame
                                            ]?.url
                                          : window.engravingImage.frames?.[1]?.url)
                                    : null
                                const img2 = face2Name
                                    ? 'https:' +
                                      (isBackOnly
                                          ? window.engravingImage.frames?.[
                                                window.engravingImage.frame
                                            ]?.url
                                          : window.engravingImage.frames?.[2]?.url)
                                    : null
                                const images = {
                                    face1: {
                                        image: face1LinesAvailable ? img1 : null,
                                        name: face1LinesAvailable ? face1Name : null
                                    },
                                    face2: {
                                        image: face2LinesAvailable ? img2 : null,
                                        name: face2LinesAvailable ? face2Name : null
                                    }
                                }
                                setEngravingImages(images)
                                setDesktopGalleryEngImages(images)
                                setShowApiSpinner(true)
                                saveRecipe().then((result) => {
                                    setDriveRecipeID(result.id)
                                    const activeStates = {
                                        face_1: {
                                            name: 'face_1-text',
                                            hasValue: isBackOnly ? false : !!face1LinesAvailable,
                                            value: isBackOnly
                                                ? ''
                                                : selectedFont?.face_1 === 'Monogram'
                                                ? engravingLines?.face_1.monogram
                                                : `${engravingLines.face_1.line1 || ''}
                                                                    ${
                                                                        engravingLines.face_1.line2
                                                                            ? '\n' +
                                                                              engravingLines.face_1
                                                                                  .line2
                                                                            : ''
                                                                    }
                                                                    ${
                                                                        engravingLines.face_1.line3
                                                                            ? '\n' +
                                                                              engravingLines.face_1
                                                                                  .line3
                                                                            : ''
                                                                    }
                                                                    ${
                                                                        engravingLines.face_1.line4
                                                                            ? '\n' +
                                                                              engravingLines.face_1
                                                                                  .line4
                                                                            : ''
                                                                    }
                                                                    ${
                                                                        engravingLines.face_1.line5
                                                                            ? '\n' +
                                                                              engravingLines.face_1
                                                                                  .line5
                                                                            : ''
                                                                    }`.trim(),
                                            fontFamily: selectedFont.face_1
                                        },
                                        face_1_right: {
                                            name: 'face_1-right-text',
                                            hasValue: false,
                                            value: ''
                                        },
                                        face_2: {
                                            name: 'face_2-text',
                                            hasValue: !!face2LinesAvailable,
                                            value:
                                                selectedFont?.[isBackOnly ? 'face_1' : 'face_2'] ===
                                                'Monogram'
                                                    ? engravingLines?.[
                                                          isBackOnly ? 'face_1' : 'face_2'
                                                      ]?.monogram
                                                    : `${
                                                          engravingLines?.[
                                                              isBackOnly ? 'face_1' : 'face_2'
                                                          ].line1 || ''
                                                      }${
                                                          engravingLines?.[
                                                              isBackOnly ? 'face_1' : 'face_2'
                                                          ].line2
                                                              ? '\n' +
                                                                engravingLines?.[
                                                                    isBackOnly ? 'face_1' : 'face_2'
                                                                ].line2
                                                              : ''
                                                      }${
                                                          engravingLines?.[
                                                              isBackOnly ? 'face_1' : 'face_2'
                                                          ].line3
                                                              ? '\n' +
                                                                engravingLines?.[
                                                                    isBackOnly ? 'face_1' : 'face_2'
                                                                ].line3
                                                              : ''
                                                      }${
                                                          engravingLines?.[
                                                              isBackOnly ? 'face_1' : 'face_2'
                                                          ].line4
                                                              ? '\n' +
                                                                engravingLines?.[
                                                                    isBackOnly ? 'face_1' : 'face_2'
                                                                ].line4
                                                              : ''
                                                      }${
                                                          engravingLines?.[
                                                              isBackOnly ? 'face_1' : 'face_2'
                                                          ].line5
                                                              ? '\n' +
                                                                engravingLines?.[
                                                                    isBackOnly ? 'face_1' : 'face_2'
                                                                ].line5
                                                              : ''
                                                      }`.trim(),
                                            fontFamily:
                                                selectedFont?.[isBackOnly ? 'face_1' : 'face_2']
                                        },
                                        face_2_right: {
                                            name: 'face_2-right-text',
                                            hasValue: false,
                                            value: '',
                                            fontFamily: ''
                                        }
                                    }
                                    setEngravingChecksum(getHash(activeStates))
                                    setShowApiSpinner(false)
                                    onClose()
                                    setOpenEngraving(false)
                                    window.scrollTo({top: 0, behavior: 'smooth'})
                                })
                            } else {
                                setEngravingChecksum(null)
                                setEngravingImages({
                                    face1: null,
                                    face2: null
                                })
                                setDesktopGalleryEngImages(null)
                                setShowApiSpinner(false)
                                onClose()
                                setOpenEngraving(false)
                            }
                            tagManager.saveEngraving()
                            const engravingGtmObject = makeEngravingGtmObject(
                                selectedFont,
                                engravingLines
                            )
                            setEngravingGtmObject(engravingGtmObject)
                        }}
                    >
                        <FormattedMessage id="save.engraving" defaultMessage="Save Engraving" />
                    </Button>
                )}
                {!isEditEngraving && (
                    <Text
                        display={{base: 'block', md: 'none'}}
                        color="black.100"
                        fontSize="14px"
                        fontWeight="300"
                        letterSpacing="0.07px"
                    >
                        <FormattedMessage id="or" defaultMessage="or" />
                    </Text>
                )}
                <Button
                    variant="link"
                    height="fit-content"
                    width={{sm: 'fit-content', md: '100%'}}
                    letterSpacing="0.07px"
                    fontSize="14px"
                    fontWeight="300"
                    textDecoration="underline"
                    textUnderlineOffset="4px"
                    color="black.100"
                    borderRadius="90px"
                    onClick={async () => {
                        tagManager.doNotEngrave()
                        setEngravingImages({
                            face1: null,
                            face2: null
                        })
                        setDesktopGalleryEngImages(null)
                        onClose()
                        setOpenEngraving(false)
                        if (isEditEngraving) {
                            const item = {
                                productId: product?.id,
                                quantity: parseInt(productQuantity),
                                c_borderfreeEngravingProductId: null,
                                c_driveProductID: null,
                                c_driveRecipeID: null,
                                c_driveRecipeImage: null,
                                c_driveRecipeLocation: null,
                                c_hasEngraving: false,
                                c_driveWishlistImage: null,
                                c_engraveType: null,
                                c_engravingChecksum: null,
                                c_engravingDetails: null
                            }
                            await updateItemInBasketMutation.mutateAsync({
                                parameters: {
                                    basketId: basket?.basketId,
                                    itemId: productUuid
                                },
                                body: item
                            })
                            showToast({
                                title: intl.formatMessage({
                                    id: 'engraving.removed',
                                    defaultMessage: 'Engraving has been removed from this product.'
                                }),
                                status: 'success'
                            })
                            navigate(location.pathname)
                        }
                    }}
                >
                    <FormattedMessage id="do.not.engrave" defaultMessage="Do not Engrave" />
                </Button>
            </Box>
        </Box>
    )
}

EngravingButtons.propTypes = {
    showInitialSpinner: PropTypes.bool,
    isRedtrictedWordActive: PropTypes.bool,
    engravingLines: PropTypes.oneOfType([
        PropTypes.arrayOf(
            PropTypes.shape({
                monogram: PropTypes.string,
                line1: PropTypes.string,
                line2: PropTypes.string,
                line3: PropTypes.string,
                line4: PropTypes.string,
                line5: PropTypes.string
            })
        ),
        PropTypes.shape({
            face_1: PropTypes.shape({
                monogram: PropTypes.string,
                line1: PropTypes.string,
                line2: PropTypes.string,
                line3: PropTypes.string,
                line4: PropTypes.string,
                line5: PropTypes.string
            })
        })
    ]),
    restrictionListArray: PropTypes.array,
    selectedFont: PropTypes.shape({
        face_1: PropTypes.string
    }),
    disableAddToBag: PropTypes.bool,
    setShowApiSpinner: PropTypes.func,
    setEngravingImages: PropTypes.func,
    setDesktopGalleryEngImages: PropTypes.func,
    saveRecipe: PropTypes.func,
    setDriveRecipeID: PropTypes.func,
    getHash: PropTypes.func,
    makeEngravingGtmObject: PropTypes.func,
    addToCart: PropTypes.func,
    variant: PropTypes.object,
    onAddToCartDrawerOpen: PropTypes.func,
    product: PropTypes.object,
    priceData: PropTypes.object,
    setOpenBonusModal: PropTypes.func,
    monetate: PropTypes.shape({
        monetateTrackPage: PropTypes.func
    }),
    customer: PropTypes.shape({
        customerType: PropTypes.string
    }),
    wishlist: PropTypes.shape({
        customerProductListItems: PropTypes.arrayOf(PropTypes.object)
    }),
    setShowAddedCta: PropTypes.func,
    tagManager: PropTypes.shape({
        addToCart: PropTypes.func,
        saveEngraving: PropTypes.func,
        doNotEngrave: PropTypes.func
    }),
    onClose: PropTypes.func,
    navigate: PropTypes.func,
    setOpenEngraving: PropTypes.func,
    setEngravingChecksum: PropTypes.func,
    setEngravingGtmObject: PropTypes.func,
    isEditEngraving: PropTypes.bool,
    showAddedCta: PropTypes.bool,
    productQuantity: PropTypes.number,
    updateItemInBasketMutation: PropTypes.shape({
        mutateAsync: PropTypes.func
    }),
    basket: PropTypes.shape({
        basketId: PropTypes.string
    }),
    productUuid: PropTypes.string
}

export default EngravingButtons
